import { FormControl, Grid, MenuItem, Select, Typography, Box, Snackbar, Tooltip, Button, Dialog as MuiDialog, DialogContent, DialogTitle } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { useEffect, useContext, useState } from 'react';

import { AppContext } from '../../../../RoutesWithAuth';

import { LoadingIndicator, Tab, Tabs } from '../reports/reconcilationreport/MuiStyled';

import { withNavbar } from '../Navbar';
import { withRouterProps } from '../../../common/withRouterProps';

import { Cancel, Close, Delete, FindInPage, History, Rule, Save, ContentCopy } from '@mui/icons-material';
import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { standardButtonStyle, cancelButtonStyle } from './buttonStyles';
import PermissionButton from '../PermissionButton';
import { HOME_PERMISSIONS } from '../../../common/RolePermissions';
import axios from '../../../common/AxiosConfig';

import { DATEFORMATLOCAL, DATEFORMATUTC, v2UIRoutePath } from '../../../common/commons';

import moment from 'moment';
import 'moment-duration-format';

import { Alert } from '@mui/lab';

import ListOfItems from './ListOfItems';

import { CustomerDetailsGridColumns, DetailsViewTabs, ListOfFields, ListOfrequestDetails, OtherRequestorGridColumns, TVLAGridColumns, ViewRequestOptions } from './constants';

import uniq from 'lodash/uniq';

import RequestDetailsJSONTabs from './viewRequestTabs/index';

import Dialog from '../Dialog';

import Applications from './applications';

import AuditTrail from './AuditTrail';

import StatusUpdate from './StatusUpdate';
import DeleteDialog from '../admin/settings/DeleteDialog';
import { horizontalTabStyles } from '../sharedStyles';

const useStyles = makeStyles(() => ({

    homePageWrapper: {
        background: '#f8fafc',
        minHeight: '100vh',
        paddingBottom: '20px',
        position: 'relative',
    },
    headerTitle: {
        textAlign: "center",
        flexGrow: 1,
        fontWeight: 700,
        fontSize: '1.1rem',
        color: '#1e3a5f',
        padding: '14px 0 10px',
        letterSpacing: '0.5px',
        textTransform: 'uppercase',
        position: 'relative',
        '&::after': {
            content: '""',
            display: 'block',
            width: '50px',
            height: '3px',
            background: 'linear-gradient(90deg, #267db7, #3b9edd)',
            borderRadius: '2px',
            margin: '8px auto 0',
        },
    },
    headerBanner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0',
        padding: '0 16px',
        background: 'linear-gradient(135deg, #1e3a5f 0%, #267db7 125%, #3b9edd 100%)',
        borderRadius: '10px',
        margin: '0 16px 16px',
        border: 'none',
        flexWrap: 'wrap',
        boxShadow: '0 2px 12px rgba(30,58,95,0.15)',
        minHeight: '48px',
    },
    bannerField: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '6px',
        fontSize: '0.82rem',
        color: 'rgba(255,255,255,0.8)',
        padding: '12px 20px',
        borderRight: '1px solid rgba(255,255,255,0.2)',
        '&:last-child': {
            borderRight: 'none',
        },
        '& b': {
            color: '#daa520',
            fontSize: '0.75rem',
            fontWeight: 500,
            letterSpacing: '0.6px',
            textTransform: 'uppercase',
            borderBottom: '1.5px solid #daa520',
        },
        '& .field-value': {
            color: '#2f4f4f',
            fontWeight: 700,
            fontSize: '0.88rem',
        },
    },
    copyIcon: {
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        color: 'rgba(255,255,255,0.85)',
        fontSize: '0.95rem',
        '&:hover': {
            color: '#daa520',
        },
    },
    requestDetailsWrapper: {
        background: '#fff',
        height: "100%",
        padding: '20px',
        '& .isInactive-row-cust-cls': {
            color: '#dc3545'
        },
        '& .MuiButton-root': {
            padding: '5px 25px',
            fontSize: '0.8rem',
            textTransform: 'none',
            '&:not(.Mui-disabled)': {
                background: 'linear-gradient(180deg, #3b9edd 0%, #267db7 54%, #1e3a5f 125%)',
            },
        }
    },
    headerList: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '15px',
        marginLeft: '10px',
        marginRight: '20px',
        marginBottom: '15px',
        fontSize: "0.85rem"
    },
    ListTop: {
        justifyContent: "center",
        '& .listitemWrapper': {
            marginRight: '15px'
        }
    },
    ListInsideViewDetails: {
        justifyContent: 'space-between',
        paddingTop: '15px',
        alignItems: 'baseline'
    },
    requestordetailsGridWrapper: {
        padding: '0',
        margin: '20px 0 0',
        borderRadius: '10px',
        overflow: 'hidden',
        border: '1px solid #e2e8f0',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        '& .header': {
            background: 'linear-gradient(135deg, #1e3a5f 0%, #267db7 125%, #3b9edd 100%)',
            padding: '11px 18px',
            color: "white",
            fontWeight: 600,
            fontSize: '0.85rem',
            letterSpacing: '0.4px',
        },
        '& table': {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '0.85rem',
        },
        '& thead': {
            background: '#778899',
            position: 'sticky',
            top: 0,
            zIndex: 10,
        },
        '& th': {
            padding: '12px 16px',
            textAlign: 'left',
            color: '#fff',
            fontWeight: 600,
            fontSize: '0.85rem',
            borderRight: '1px solid rgba(255,255,255,0.1)',
            letterSpacing: '0.3px',
            position: 'sticky',
            top: 0,
            background: '#778899',
            userSelect: 'none',
            zIndex: 9,
            '&:last-child': {
                borderRight: 'none',
            },
        },
        '& .resize-handle': {
            position: 'absolute',
            right: 0,
            top: 0,
            bottom: 0,
            width: '8px',
            cursor: 'col-resize',
            userSelect: 'none',
            zIndex: 1,
            '&:hover': {
                background: 'rgba(255,255,255,0.2)',
            },
        },
        '& tbody tr': {
            background: '#fff',
            borderBottom: '1px solid #edf2f7',
            transition: 'background-color 0.2s ease',
            '&:nth-of-type(odd)': {
                background: '#f8fafc',
            },
            '&:hover': {
                background: '#f0f7ff',
            },
        },
        '& td': {
            padding: '12px 16px',
            borderRight: '1px solid #edf2f7',
            color: '#334155',
            fontSize: '0.85rem',
            maxWidth: '250px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            '&:last-child': {
                borderRight: 'none',
            },
        },
    },
    homePageWrapper: {
        fontSize: '0.85rem',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        background: '#f0f4f8',
        '& .MuiTab-root': {
            maxWidth: "100%"
        },
        '& .requestDetailsWrapper': {
                border: '1px solid #6591b696',
                height: '100%',
                padding: '20px',
                background: '#fff',
                borderRadius: '10px 10px',
            '& .isInactive-row-cust-cls': {
                color: '#dc3545'
            },
            '& .MuiButton-root': {
                padding: '5px 25px',
                fontSize: '0.7rem',
                textTransform: 'none',
                '&:not(.Mui-disabled)': {
                    background: 'linear-gradient(180deg, #3b9edd 0%, #267db7 54%, #1e3a5f 125%)',
                },
            }
        }
    },
    appsScopeWrapper: {
        margin: '0 16px',
        ...horizontalTabStyles.tabWrapper,
        '& .scopeHeader': {
            padding: '10px 20px',
            fontSize: '1rem',
            fontWeight: 'bold',
            '& a': {
                color: "#212529"
            }
        },
    },
    iconActionBtn: {
        padding: '5px 16px',
        fontSize: '0.7rem',
        textTransform: 'none',
        background: 'linear-gradient(180deg, #3b9edd 0%, #267db7 54%, #1e3a5f 125%)',
        color: '#fff',
        fontWeight: 500,
        borderRadius: '4px',
        whiteSpace: 'nowrap',
        '&:hover': {
            background: 'linear-gradient(180deg, #2a8acc 0%, #1e6aa6 54%, #162d4e 125%)',
        },
    },
    IconActions: {
        display: 'flex',
        gap: '8px',
        flexShrink: 0,
    },
    tabBarRow: {
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        margin: '0 16px',
    },
    bannerFieldsContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0',
        flexWrap: 'wrap',
        flex: 1,
    },
    sectionCard: {
        background: '#fff',
        borderRadius: '10px',
        border: '1px solid #e2e8f0',
        padding: '16px 20px',
        boxShadow: '0 1px 6px rgba(0,0,0,0.04)',
        height: '100%',
    },
    sectionLabel: {
        fontWeight: 600,
        fontSize: '0.82rem',
        color: '#1e3a5f',
        marginBottom: '10px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        textTransform: 'uppercase',
        letterSpacing: '0.3px',
        fontSize: '0.72rem',
    },
    tabCloseIcon: {
        marginLeft: '6px',
        padding: '2px',
        borderRadius: '50%',
        '&:hover': {
            background: 'rgba(255,255,255,0.2)',
        },
    },
}));


function RequestDetailView(props) {
    const { routerProps } = props
    const classes = useStyles();
    const { history, match } = routerProps;
    const { dsarRequestId } = match.params;
    const context = useContext(AppContext)
    const authToken = context.authToken.get
    const isAdmin = context.isAdmin.get
    // State to handle the API loading state
    const [isLoading, setIsLoading] = useState(false);
    //state to handle the Active Tab Index
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    // state to handle the Request details response from the API
    const [requestDetails, setRequestDetails] = useState({});
    // state to handle the note details
    const [newNote, setNewNote] = useState(null);
    // state to handle the node editable field
    const [noteEditable, setNoteEditable] = useState(false);
    // state to handle the view request state
    const [viewRequest, setViewRequest] = useState("cpsrequestjson");
    // state to handle the ticket details api data
    const [systems, setSystems] = useState([]);
    // state to handle the error message
    const [displayErrMsg, setDisplayErrMsg] = useState(null);
    const [displayManualReviewDetails, setDisplayManualReviewDetails] = useState(false);
    const [manualReviewData, setManualReviewData] = useState();
    // state to handle selected rows in manual review dialog
    const [selectedManualReviewRows, setSelectedManualReviewRows] = useState([]);
    // state to handle confirmation dialog for remove & reconsolidate
    const [showRemoveConfirmation, setShowRemoveConfirmation] = useState(false);
    // state to handle the sucess message
    const [displaySuccessMsg, setDisplaySuccessMsg] = useState(null);
    // state to toggle the copy tooltip text after copying the DSAR ID
    const [copiedDsarId, setCopiedDsarId] = useState(false);

    const [displayAuditTrail, setDisplayAuditTrail] = useState(false);

    const [activeTabs, setActiveTabs] = useState({});

    const [displayStatusUpdate, setDisplayStatusUpdate] = useState(false);

    // state to handle vehicle generation data
    const [vehicleGenData, setVehicleGenData] = useState({});
    const [showVehiclesPopup, setShowVehiclesPopup] = useState(false);
    
    // state to handle column widths for resizable table
    const [columnWidths, setColumnWidths] = useState({});

    useEffect(() => {
        if (authToken !== null) {
            fetchData();
        }
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[authToken]);

    /**
     * Method returns the requestor type 
     * @param {String} requestorParam Optional param passed when it should be given high preference than the state data 
     * @returns boolean 
     * true when its is customer and tci customer requestor
     * false when its other than customer and tci customer
     */
    const isCustomerRequestor = (requestorParam) => {

        let requestor = requestorParam || requestDetails.requestor || "";
        // transform to lowercase and validate with customer and tci customer
        const validRequestors = new Set(["customer", "tci customer", "survivor"]);
        return validRequestors.has(requestor.toLowerCase());

}

    const isTVLARequest = () => {
        const ticketType = requestDetails.ticket_type || "";
        return ["Terminate-Vehicle-Location-Access", "TVLA"].includes(ticketType);
    }

    const getFormatedDate = (date, isUTC) => {
        if (!date) {
            return null;
        }
        if (isUTC) {
            return moment(date)
                .utc()
                .format(DATEFORMATUTC)
        } else {
            return moment(date)
                .local()
                .format(DATEFORMATLOCAL)
        }
    }
    /**
     * Method is used to call the app tickets data and store the response in the systems state
     */
    const fetchAppTicketDetails = () => {

        axios.get(`app_tickets/${dsarRequestId}`, {
            headers: {
                Authorization: authToken,
            },
        })
            .then((res) => {
                // formating the app info
                let appInfo = res.data;
                // sorting the app info based on the display name
                appInfo = appInfo.sort((a, b) => a.display.localeCompare(b.display))
                appInfo = appInfo.map((_appInfo) => {
                    let system_generated_ticket_id = _appInfo.system_generated_ticket_id;
                    if (system_generated_ticket_id === dsarRequestId) {
                        system_generated_ticket_id = null;
                    }
                    return {
                        ..._appInfo,
                        system_generated_ticket_id,
                        is_request_automated: _appInfo.is_request_automated ? 'Yes' : 'No',
                        is_response_automated: _appInfo.is_response_automated ? 'Yes' : 'No',
                        created_date_local: getFormatedDate(_appInfo.created_date, false),
                        created_date_utc: getFormatedDate(_appInfo.created_date, true),
                        response_created_date_local: getFormatedDate(_appInfo.response_created_date, false),
                        response_created_date_utc: getFormatedDate(_appInfo.response_created_date, true)
                    }
                })
                setSystems(appInfo);
            })
            .catch((err) => {
                console.log("Error fetching downstream app tickets:", err);
                // Note: Empty array is valid - request may not have downstream apps
                // Only log errors, don't show user-facing error message
            });
    }
    /**
     * Method to trigger the ticket details api
     */
    const fetchRequestDetails = () => {
        axios.get(`ticket/search/`, {
            headers: {
                Authorization: authToken,
            },
            params: {
                id: dsarRequestId,
                include_open: true,
                include_closed: true,
                exact_match: true,
            },
        })
            .then((res) => {
                // Trigger the loading state 
                setIsLoading(false);
                // Handle the case where the request does not exist
                if (res.data.length === 0) {

                    return;
                }
                const requestRecord = res.data[0];
                // formating the ticket details
                formatRequestDetails(requestRecord);
            })
            .catch((err) => {
                // updating the loading state to false
                setIsLoading(false);
                // Display the Toast message in the UI.
                console.log("Error fetching request details:", err)
                setDisplayErrMsg("There was an error fetching request details!")
            });
    }
    /**
     * Method is used to format the response based on the UI need
     * @param {Backend response} requestRecord 
     */
    const formatRequestDetails = (requestRecord) => {
        const requestDetails = {
            ...requestRecord,
            created_date_utc: getFormatedDate(requestRecord.created_date, true),
            created_date_local: getFormatedDate(requestRecord.created_date, false),
            cali_cust_flag: requestRecord.cali_customer ? "Yes" : "No",
            note_updated_time_utc: getFormatedDate(requestRecord.note_updated_time, true),
            note_updated_time_local: getFormatedDate(requestRecord.note_updated_time, false),
            data_uploaded_time_local: getFormatedDate(requestRecord.tips_ack_time, false),
            data_uploaded_time_utc: getFormatedDate(requestRecord.tips_ack_time, true),
            response_generated_time_local: getFormatedDate(requestRecord.processing_start_time, false),
            response_generated_time_utc: getFormatedDate(requestRecord.processing_start_time, true),
        };
        if (requestRecord.tips_ack_time && requestRecord.processing_start_time) {
            requestDetails["processing_time"] = moment
                .duration(
                    moment(requestRecord.tips_ack_time).diff(moment(requestRecord.created_date))
                )
                .format("d [days], h [hours], m [minutes], s [seconds]", {
                    trim: "both mid",
                })
        }
        // Method parses the consumer profile info from the dsar json.
        const consumerProfileData = getConsumerProfileData(requestRecord?.dsar);
        // considering the personas available in the consumer dsar json.
        requestDetails["personas"] = consumerProfileData["personas"];
        // dynamically setting the consumer_type and table data based on the requestor.
        const isTVLATicketType = ["Terminate-Vehicle-Location-Access", "TVLA"].includes(requestRecord.ticket_type);
        if (isTVLATicketType) {
            requestDetails["consumer_type"] = consumerProfileData["consumerType"];
            requestDetails["requestorDetailsTable"] = processTableDataForTVLA(requestRecord);
        } else if (isCustomerRequestor(requestDetails.requestor)) {
            // Displaying the Consumer type from the dsar json 
            requestDetails["consumer_type"] = requestRecord?.dsar?.consumerTypes?.[0]?.consumerType;
            requestDetails["requestorDetailsTable"] = processTableCustomerTypeData(requestRecord);
        } else {
            requestDetails["consumer_type"] = consumerProfileData["consumerType"];
            requestDetails["requestorDetailsTable"] = processTableDataForOtherRequestorTypes(requestRecord.dsar);
        }


        // Updating the state with the formated response
        setRequestDetails(requestDetails);
        if(["Closed","Uploaded","Upload Failed"].includes(requestDetails.status) || requestDetails.has_consolidated_response){
            const activeSelection = `CONSOLIDATED-RESPONSE`;
            const allTabs = {
                [activeSelection]: {
                    dsarRequestId,
                    "tabtype": "consolidatedresponse",
                    tabname : "CONSOLIDATED RESPONSE",
                    hideCloseIcon : true
                },
                ...activeTabs,
            };
            setActiveTabs(allTabs);
        } else {
            const indexOfConsolidated = Object.keys(activeTabs).indexOf("CONSOLIDATED-RESPONSE");
            if( indexOfConsolidated !== -1 ){
                if((activeTabIndex - 2 ) === 0 )
            setActiveTabIndex(0);
            }
            delete activeTabs["CONSOLIDATED-RESPONSE"]
            setActiveTabs({ ...activeTabs });
        }
    }
    const fetchVehicleGeneration = () => {
        axios.get(`ticket/${dsarRequestId}/request/`, {
            headers: { Authorization: authToken },
            params: { payload_type: 'vehicle_gen' }
        })
        .then((res) => {
            const message = res.data?.message || {};
            setVehicleGenData(message);
        })
        .catch((err) => {
            console.log("Error fetching vehicle generation data:", err);
        });
    }

    const getVehicleGenInfo = () => {
        const entries = Object.entries(vehicleGenData);
        if (entries.length === 0) return { display: '--', vehicles: [] };

        // Deduplicate VINs (keep first occurrence)
        const vinMap = {};
        entries.forEach(([vin, gen]) => {
            if (!vinMap[vin]) {
                vinMap[vin] = gen;
            }
        });

        // Sort VINs alphabetically and create vehicles list
        const vehicles = Object.entries(vinMap)
            .sort(([a], [b]) => a.localeCompare(b))
            .map(([vin, gen], index) => ({
                id: index + 1,
                vin,
                generation: gen || '--'
            }));

        // Get distinct generations sorted alphabetically
        const generations = [...new Set(
            Object.values(vinMap).filter(gen => gen != null)
        )].sort().join(', ');

        return { display: generations || '--', vehicles };
    }

    const fetchData = () => {
        setIsLoading(true);
        // fetch ticket details based on the dsar ID
        fetchAppTicketDetails();
        // fetch dsar info based on the dsar ID
        fetchRequestDetails();
        // fetch vehicle generation data
        fetchVehicleGeneration();
    }
    /**
     * Method is used to parse the personas details from the consumerProfileData of the dsar form
     * @param {*} dsar 
     * @returns List of personas details with comma seperated
     */
    const getConsumerProfileData = (dsar) => {
        const consumerProfileData = dsar?.consumerProfileData || [];
        const personas = {};
        const consumerType = {};
        consumerProfileData.forEach((_consumerProfileData) => {
            const verifiedPersonas = _consumerProfileData?.verifiedPersonas || [];
            verifiedPersonas.forEach((verifiedPersona) => {
                personas[verifiedPersona] = verifiedPersona;
            })

            const subjectWorkerInfo = _consumerProfileData?.subjectWorkerInfo || [];
            subjectWorkerInfo.forEach((_subjectWorkerInfo) => {
                consumerType[_subjectWorkerInfo?.subjectWorkerStatus?.toLowerCase()] = _subjectWorkerInfo?.subjectWorkerStatus;
                consumerType[_subjectWorkerInfo?.subjectWorkerDetailedStatus?.toLowerCase()] = _subjectWorkerInfo?.subjectWorkerDetailedStatus;
            });

            const subjectDealerInfo = _consumerProfileData?.subjectDealerInfo || [];
            subjectDealerInfo.forEach((_subjectDealerInfo) => {
                consumerType[_subjectDealerInfo?.subjectDealerStatus?.toLowerCase()] = _subjectDealerInfo?.subjectDealerStatus;
            });

        });
        // joining the personas with the comma seperated
        return {
            personas: Object.keys(personas).join(' , '),
            consumerType: Object.values(consumerType).join(' , '),
        }
    }
    // Method is used to process table data from the dsar form for customer type
    const processTableCustomerTypeData = (requestRecord) => {
        const { dsar} = requestRecord;
        const { dsarForm: { subjectEmails=[], subjectNames=[] }, consumerProfileData=[] } = dsar;
        const dsarFormFnames = [];
        const dsarFormLnames = [];
        const dsarFormEmails = [];
        const dsarFormRecord = {}
        // forming the lnames and fnames
        subjectNames.forEach(({ subjectFirstName, subjectLastName }) => {
            dsarFormFnames.push(subjectFirstName);
            dsarFormLnames.push(subjectLastName);
        });
        // forming the emails
     
        subjectEmails.forEach(({ subjectEmail }) => {
            dsarFormEmails.push(subjectEmail);
        });
        // updating the form data with comma seperated
        dsarFormRecord["firstname"] = dsarFormFnames.join(', ');
        dsarFormRecord["lastname"] = dsarFormLnames.join(', ');
        dsarFormRecord["email"] = dsarFormEmails.join(", ");
         if (["ISR", "Right-to-Terminate", "Right-to-Create"].includes(requestRecord.ticket_type)) {
            dsarFormRecord["vins"] = requestRecord?.vin_info?.vin?.join(", ") || '';
        } else if (["Add-Whitelist", "Remove-Whitelist", "Unflag-VIN"].includes(requestRecord.ticket_type)) {
            const vinsArray = requestRecord?.dsar?.dsarForm?.subjectVehicle?.map(vehicle => vehicle.subjectVIN) || [];
            dsarFormRecord["vins"] = vinsArray.join(", ");
        }
        // creating the first record from the dsar form,
        const tableData = []
        tableData.push({
            id: "1",
            custId: "",
            guid: "",
            ...dsarFormRecord
        })
        // Displaying the consumerprofile data as the 2nd record in the grid
        consumerProfileData.forEach((_consumerProfile, index) => {
            let fnames = [];
            let lnames = [];
            let guids = [];
            // retriving the fname and the lname
            if (_consumerProfile?.consumerNames) {

            _consumerProfile.consumerNames.forEach((consumerName) => {
                fnames.push(consumerName.firstName);
                lnames.push(consumerName.lastName);
            })
        }
            // customer ID column in the grid
            const customerId = _consumerProfile?.consumerProfileMetadata?.customerId;
            const emails = _consumerProfile?.communicationInfo?.emailInfo?.map(({ email }) => email) || [];
            if ( _consumerProfile?.linkedIds) {

            _consumerProfile.linkedIds.forEach((linkedId) => {
                guids.push(...(linkedId?.azureUserIds || []));
            })
        }
            const _vins =  _consumerProfile?.vehicleInfo?.map((_vehicleInfo) => {
                return _vehicleInfo.vin
            }) || [];
            // loading the formed data into the table data
            tableData.push({
                id: 1 + (index + 1),
                custId: customerId,
                guid: guids.join(", "),
                vins: _vins.join(", "),
                firstname: fnames.join(', '),
                lastname: lnames.join(", "),
                email: emails.join(', ')
            })

        })
        return tableData;
    }
    // Method is used to process table data for TVLA (Terminate Vehicle Location Access) requests
   const processTableDataForTVLA = (requestRecord) => {
        const tcCaseNumber = requestRecord?.dsar.dsarForm.subjectTCCaseNumber || '';
        const vins = requestRecord?.dsar.dsarForm.subjectVIN || '';
        return [{
            id: "1",
            tcCaseNumber,
            vins
        }];
    }
    // Method is used to process table data from the dsar form for other Requestor like B2b and Employee
    const processTableDataForOtherRequestorTypes = (dsar) => {
        const { dsarForm: {
            subjectEmails=[],
            subjectNames=[],
            subjectWorkdayId,
            subjectDealerSpinId,
            subjectBusinessEmails=[]
        }, consumerProfileData=[] } = dsar;
        let dsarFormFnames = [];
        let dsarFormLnames = [];
        let dsarFormEmails = [];
        let dsarFormRecord = {}
        // forming the lnames and fnames
        subjectNames.forEach(({ subjectFirstName, subjectLastName }) => {
            dsarFormFnames.push(subjectFirstName);
            dsarFormLnames.push(subjectLastName);
        });
        // forming the emails
    
        subjectEmails.forEach(({ subjectEmail }) => {
            if(subjectEmail){
            dsarFormEmails.push(subjectEmail);
            }
        });


        // formating the subjectBusinessEmail
    
        subjectBusinessEmails.forEach(({ subjectBusinessEmail }) => {
            if(subjectBusinessEmail){
            dsarFormEmails.push(subjectBusinessEmail);
            }
        });
    

        // updating the form data with comma seperated
        dsarFormRecord["firstname"] = dsarFormFnames.join(', ');
        dsarFormRecord["lastname"] = dsarFormLnames.join(', ');
        dsarFormRecord["email"] = uniq(dsarFormEmails).join(", ");
        dsarFormRecord["workdayId"] = subjectWorkdayId;
        dsarFormRecord["spinId"] = subjectDealerSpinId;

        const tableData = []
        // Loading the first record with the dsarForm Data
        tableData.push({
            id: "1",

            ...dsarFormRecord
        })   
        // Duisplaying the consumerprofile data as the 2nd record in the grid
        consumerProfileData.forEach((_consumerProfile, index) => {
            let consumerRecord = {
                firstname: [],
                lastname: [],
                email: [],
                workdayId: [],
                applicationId: [],
                spinId: [],
                loginId: [],
                workertype: [],
                dealerCode: [],
                GUID: []
            }
            // retriving the fname and the lname
            if(_consumerProfile?.consumerNames){
            _consumerProfile.consumerNames.forEach((consumerName) => {
                consumerRecord.firstname.push(consumerName.firstName);
                consumerRecord.lastname.push(consumerName.lastName);
            });
        }
        
            consumerRecord.email = _consumerProfile?.communicationInfo?.emailInfo?.map(({ email }) => email) || [];
        if(_consumerProfile?.subjectWorkerInfo){
          _consumerProfile.subjectWorkerInfo.forEach((_subjectWorkerInfo) => {
                consumerRecord.workertype.push(_subjectWorkerInfo?.subjectWorkerType || "");
                consumerRecord.email.push(_subjectWorkerInfo?.subjectWorkerEmail || "");
                consumerRecord.workdayId.push(_subjectWorkerInfo?.subjectWorkDayId || "");

            })
        }
        if(_consumerProfile?.subjectDealerInfo){
            _consumerProfile.subjectDealerInfo.forEach((_subjectDealerInfo) => {
                let spinId = _subjectDealerInfo?.subjectDealerSpinId || "";
                consumerRecord.dealerCode.push(_subjectDealerInfo?.subjectDealerCode || "");
                consumerRecord.spinId.push(spinId)
            });
        }
        if(_consumerProfile?.linkedIds){
            _consumerProfile.linkedIds.forEach((linkedId) => {
                consumerRecord.GUID.push(...(linkedId?.azureUserIds || []));
                consumerRecord.workdayId.push(...(linkedId?.workdayIds || []))
                consumerRecord.applicationId.push(...(linkedId?.applicantIds || []))
                consumerRecord.loginId.push(...(linkedId?.loginIds || []))
                consumerRecord.spinId.push(...(linkedId?.spinIds || []))
            })
        }
            Object.keys(consumerRecord).forEach((_consumer_key) => {
                consumerRecord[_consumer_key] = uniq(consumerRecord[_consumer_key]).join(", ");
            })
            // loading the formed data into the table data
            tableData.push({
                id: 1 + (index + 1),
                ...consumerRecord
            });

        })
        return tableData;
    }
    const handleViewReviewButton = () => {
        setDisplayManualReviewDetails(true);
        axios.get(`/review/details/${dsarRequestId}`, {
            headers: {
                Authorization: authToken,
            },
        })
            .then((res) => {
                let reviewData = res.data;
                setManualReviewData(reviewData);
            })
            .catch((err) => {
                console.log("There was an error fetching Manual Review Data!");
                setDisplayErrMsg("Failed in Fetching Manual Review Data");
                setDisplayManualReviewDetails(false);
            });
    }

    const handleLitigationHoldClick =()=>{
        history.push("/admin/systemsettings/litigation")
    }

    /**
     * Handler for checkbox selection in manual review dialog
     * @param {number} rowId - The id of the row being selected/deselected
     */
    const handleManualReviewRowSelect = (rowId) => {
        setSelectedManualReviewRows(prev => {
            if (prev.includes(rowId)) {
                return prev.filter(id => id !== rowId);
            }
            return [...prev, rowId];
        });
    }

    /**
     * Handler for select all checkbox in manual review dialog
     * @param {boolean} selectAll - Whether to select all or deselect all
     */
    const handleManualReviewSelectAll = (selectAll) => {
        if (selectAll) {
            const allIds = manualReviewData
                ?.map((row, index) => ({ id: index + 1, disabled: row.data_type === 'File-to-Attach-to-Privacy-Report' }))
                .filter(item => !item.disabled)
                .map(item => item.id) || [];
            setSelectedManualReviewRows(allIds);
        } else {
            setSelectedManualReviewRows([]);
        }
    }

    /**
     * Handler for Remove & Reconsolidate button click
     * Shows confirmation dialog
     */
    const handleRemoveAndReconsolidateClick = () => {
        setShowRemoveConfirmation(true);
    }

    /**
     * Handler for confirmation dialog close (No button)
     */
    const handleRemoveConfirmationClose = () => {
        setShowRemoveConfirmation(false);
    }

    /**
     * Handler for confirmation dialog submit (Yes button)
     * Removes selected keys from downstream response and triggers reconsolidate
     */
    const handleRemoveAndReconsolidateSubmit = () => {
        setShowRemoveConfirmation(false);
        setIsLoading(true);

        // Get the selected rows data
        const selectedData = manualReviewData?.filter((_, index) => 
            selectedManualReviewRows.includes(index + 1)
        ) || [];

        // Format the audit details: <Key1>|<value1>, <key2>|<value2> etc.
        const auditDetails = selectedData.map(row => 
            `${row.key}|${row.response_value}`
        ).join(', ');

        // Prepare payload for remove API
        const keysToRemove = selectedData.map(row => ({
            app_id: row.app_id,
            app_name: row.app_name,
            key: row.key,
            response_value: row.response_value
        }));

        // Call API to remove selected keys
        axios.post(`/review/remove/${dsarRequestId}`, {
            keys_to_remove: keysToRemove,
            audit_activity: "Manual Remove and Reconsolidate",
            audit_details: auditDetails
        }, {
            headers: {
                Authorization: authToken,
            },
        })
        .then((res) => {
            // After successful removal, trigger reconsolidate
            return axios.post(
                "/response/consolidate",
                {
                    dsar_id: requestDetails.dsar_id
                },
                {
                    headers: {
                        Authorization: authToken,
                    },
                }
            );
        })
        .then((res) => {
            setIsLoading(false);
            setDisplaySuccessMsg("Selected keys are removed and response reconsolidated successfully");
            // Reset selection
            setSelectedManualReviewRows([]);
            // Close the manual review dialog
            setDisplayManualReviewDetails(false);
            setManualReviewData(null);
            // Reload the page data
            fetchData();
        })
        .catch((err) => {
            setIsLoading(false);
            console.log(err);
            const errorMessage = err.response?.data?.message || err.message || "Unknown error";
            setDisplayErrMsg(`Error encountered. ${errorMessage}`);
        });
    }

    /**
     * Method is triggered when tick icon is triggered on the note edit.
     * Triggered the put api to update in the backend .
     */
    const updateNote = () => {
        setIsLoading(true)
        axios
            .put(
                `/ticket/${dsarRequestId}/note`,
                {
                    note: newNote.trim() !== "" ? newNote : null,
                },
                {
                    headers: {
                        Authorization: authToken,
                    },
                }
            )
            .then((res) => {
                // setting the new note based on the response
                setNewNote(res.data.new_note);
                // marking the editable as false
                setNoteEditable(false);
                // removing the loading indicator
                setIsLoading(false);
                // updating the request details with the latest reponse
                setRequestDetails({
                    ...requestDetails,
                    note_updated_by: res.data.note_updated_by,
                    note_updated_time_utc: moment(res.data.note_updated_time)
                        .utc()
                        .format(DATEFORMATUTC),
                    note_updated_time_local: moment(res.data.note_updated_time)
                        .local()
                        .format(DATEFORMATLOCAL),
                    note_updated_time: res.data.note_updated_time,
                    note: res.data.new_note
                })
            })
            .catch((err) => {
                let errMsg = "Could not update note!";
                if (err.response) {
                    errMsg = err.response.data.message;
                }
                // display the error snackbar error message
                setDisplayErrMsg(errMsg);

            })
    };
    const handleNewTabOpen = (tabInfo) =>{
        const allTabs = {
            ...activeTabs,
            [tabInfo.activeSelection]: {
                dsarRequestId,
                ...tabInfo,
            }
        };
        setActiveTabs(allTabs);
        setActiveTabIndex((Object.keys(allTabs).indexOf(tabInfo.activeSelection)) + 2);
    }
    const handleViewResponseDownstream = (tabInfo) => {
        const activeSelection = `DownstreamResponse-${tabInfo.app_id}`;
        
        handleNewTabOpen({
            activeSelection : activeSelection,
            tabtype : "downstreamappresponse",
            closeIndex: 1,
            ...tabInfo
        })
        
    }
    const handleConsolidate = () => {
        setIsLoading(true)
        axios
            .post(
                "/response/consolidate",
                {
                    dsar_id: requestDetails.dsar_id
                },
                {
                    headers: {
                        Authorization: authToken,
                    },
                }
            )
            .then((res) => {
                setIsLoading(false)
                setDisplaySuccessMsg(res.data.message);
                fetchData();
            })
            .catch((err) => {
                setIsLoading(false)
                console.log(err);
                if (err.response) {
                    setDisplayErrMsg(err.response.data.message)
                }
            });

    }
    // triggered when closing the error snackbar
    const handleClose = () => {
        // resetting the error message.
        setDisplayErrMsg(null);
        setDisplaySuccessMsg(null);
    }

    const handleCopyDsarId = (value) => {
        const markCopied = () => {
            setCopiedDsarId(true);
            setDisplaySuccessMsg('DSAR ID copied to clipboard');
            setTimeout(() => setCopiedDsarId(false), 2000);
        };
        // navigator.clipboard is unavailable on non-secure origins, fall back to a temp textarea
        if (navigator.clipboard?.writeText) {
            navigator.clipboard.writeText(value)
                .then(markCopied)
                .catch(() => setDisplayErrMsg('Unable to copy DSAR ID to clipboard'));
            return;
        }
        const tempInput = document.createElement('textarea');
        tempInput.value = value;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);
        markCopied();
    }
    let additionalTabInfo;
    if (activeTabIndex > 1) {
        const activeTabKeyInfo = Object.keys(activeTabs)[activeTabIndex - 2];
        additionalTabInfo = {
            ...activeTabs[activeTabKeyInfo]
        }
    }

    const getViewRequestOptions = () => {
        const existingAppIds = systems?.map(({ id }) => {
            return id;
        })
        return ViewRequestOptions.map((_viewOption) => {
            if (_viewOption.restrictAppId && existingAppIds.indexOf(_viewOption.restrictAppId) !== -1) {
                return {
                    ..._viewOption,
                    isHidden: false
                }
            }
            return _viewOption;
        });
    }

    const vehicleGenInfo = getVehicleGenInfo();

    const requestDetailItems = ListOfrequestDetails.map(item => {
        if (item.mapping === 'vin_generation_display') {
            return {
                ...item,
                renderCustom: () => {
                    const { display, vehicles } = vehicleGenInfo;
                    if (!display || display === '--' || vehicles.length === 0) {
                        return <span>--</span>;
                    }
                    return (
                        <a
                            href="#"
                            onClick={(e) => { e.preventDefault(); setShowVehiclesPopup(true); }}
                            style={{ color: '#267db7', fontWeight: 700, cursor: 'pointer' }}
                        >
                            {display}
                        </a>
                    );
                }
            };
        }
        return item;
    });
    return (
        <div className={`${classes.homePageWrapper}`}>
            {isLoading && (<LoadingIndicator />)}
            {displayErrMsg && <Snackbar open={!!displayErrMsg} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="error">
                    {displayErrMsg}
                </Alert>
            </Snackbar>}
            {displaySuccessMsg && <Snackbar open={!!displaySuccessMsg} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success">
                    {displaySuccessMsg}
                </Alert>
            </Snackbar>}
            <Typography variant="h6" className={classes.headerTitle}>
                Request Detail View
            </Typography>
            <div className={classes.headerBanner}>
                <div className={classes.bannerFieldsContainer}>
                    {ListOfFields.map(({ display, mapping }, index) => {
                        const value = requestDetails[mapping] || '--';
                        const isErrorStatus = display === 'Request Status' && (value === 'Review' || value === 'Upload Failed');
                        const isDsarId = mapping === 'dsar_id';
                        return (
                            <div key={display} className={classes.bannerField}>
                                <b>{display} :</b>
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                                    <span className="field-value" style={{
                                        color: isErrorStatus ? '#ef4444' : (display === 'Request Status' ? '#ffffff' : '#fff'),
                                        fontWeight: 600
                                    }}>
                                        {value}
                                    </span>
                                    {isDsarId && value !== '--' && (
                                        <Tooltip title={copiedDsarId ? 'Copied!' : 'Copy DSAR ID'}>
                                            <span
                                                role="button"
                                                tabIndex={0}
                                                aria-label="copy DSAR ID to clipboard"
                                                data-testid="copyDsarId"
                                                className={classes.copyIcon}
                                                onClick={() => handleCopyDsarId(value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                        e.preventDefault();
                                                        handleCopyDsarId(value);
                                                    }
                                                }}
                                            >
                                                <ContentCopy fontSize="inherit" />
                                            </span>
                                        </Tooltip>
                                    )}
                                </span>
                            </div>
                        )
                    })}
                </div>
            </div>
            <Box className={classes.tabBarRow}>
                <Tabs
                    variant="scrollable"
                    scrollButtons={false}
                    className={classes.appsScopeWrapper}
                    aria-label="tabs"
                    value={activeTabIndex}
                    onChange={(_event, newValue) => {
                        setActiveTabIndex(newValue);
                    }}
                    sx={{ flex: 1, minWidth: 0, margin: 0 }}
                >
                    <Tab label="REQUEST DETAILS" />
                    <Tab label="DOWN STREAM APPLICATIONS" />
                    {Object.keys(activeTabs)?.map((activeTab) => {
                        const tabInfo = activeTabs[activeTab];
                        const tabName = tabInfo.tabname || DetailsViewTabs[activeTab].tabname;
                        return (<Tab
                            key={tabName}
                            sx={{ maxWidth: '280px' }}
                            label={
                                (
                                    <span style={{ display: 'inline-flex', alignItems: 'center', maxWidth: '100%' }}>
                                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                            {tabName}
                                        </span>
                                        { !activeTabs[activeTab]?.hideCloseIcon && <span
                                            className={classes.tabCloseIcon}
                                            role="button"
                                            aria-label="close"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setActiveTabIndex(activeTabs[activeTab]?.closeIndex || 0);
                                                delete activeTabs[activeTab]
                                                setActiveTabs({ ...activeTabs });
                                            }}
                                            style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', flexShrink: 0 }}
                                        >
                                            <Close fontSize="small" />
                                        </span>
                                        }
                                    </span>
                                )
                            }
                        />)
                    })}
                </Tabs>
                <Box className={classes.IconActions}>
                    <PermissionButton 
                        permission={HOME_PERMISSIONS.AUDIT_TRAIL}
                        variant="contained"
                        className={classes.iconActionBtn} 
                        onClick={() => { setDisplayAuditTrail(true); }}
                        startIcon={<Rule sx={{ fontSize: '1rem' }} />}
                    >
                        Audit Trail
                    </PermissionButton>
                    <PermissionButton 
                        permission={HOME_PERMISSIONS.STATUS_UPDATE}
                        variant="contained"
                        className={classes.iconActionBtn} 
                        onClick={() => { setDisplayStatusUpdate(true) }}
                        startIcon={<History sx={{ fontSize: '1rem' }} />}
                    >
                        Status Update
                    </PermissionButton>
                </Box>
            </Box>
            {activeTabIndex === 0 && (
                <div className={'requestDetailsWrapper'}>
                    {requestDetails && Object.keys(requestDetails).length > 0 && (<ListOfItems
                        items={requestDetailItems}
                        data={requestDetails}
                    />)}
                    <Grid container spacing={2}>
                        <Grid item xs={4}>
                            <Box className={classes.sectionCard}>
                                <Box className={classes.sectionLabel} display="flex" justifyContent="space-between" alignItems="center">
                                    <span>Notes</span>
                                    <div style={{ fontSize: '0.72rem', color: '#6b7280', fontWeight: 400, textTransform: 'none', letterSpacing: 'normal' }}>
                                        Note Last Updated By:{" "}
                                        {requestDetails?.note_updated_by ? `${requestDetails?.note_updated_by} on` : null}
                                        {requestDetails?.note_updated_time_utc && (
                                            <Tooltip title={requestDetails.note_updated_time_local}>
                                                <span className="ml-1" id="note-updated" style={{ color: '#267db7' }}>
                                                    {requestDetails.note_updated_time_utc}
                                                </span>
                                            </Tooltip>
                                        )}
                                    </div>
                                </Box>

                                <Box
                                    display={"flex"}
                                    alignItems={"center"}>
                                    <textarea
                                        className="form-control"
                                        id="note"
                                        rows="1"
                                        placeholder="Add a note for this request"
                                        disabled={!noteEditable}
                                        value={newNote || requestDetails.note || ""}
                                        onChange={(e) => {
                                            setNewNote(e.target.value);
                                        }}
                                        style={{
                                            border: '1px solid #e2e8f0',
                                            borderRadius: '6px',
                                            padding: '8px 10px',
                                            fontSize: '0.82rem',
                                            resize: 'vertical',
                                            transition: 'border-color 0.2s ease',
                                        }}
                                        required
                                    />
                                    <Box
                                        marginLeft={"10px"}
                                    >
                                        {noteEditable ? (
                                            <Box display="flex" gap="8px">
                                                <Button
                                                    variant="contained"
                                                    startIcon={<Save />}
                                                    onClick={() => { updateNote(); }}
                                                    sx={standardButtonStyle}
                                                >
                                                    Save
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    startIcon={<Cancel />}
                                                    onClick={() => { setNoteEditable(false); setNewNote(null); }}
                                                    sx={cancelButtonStyle}
                                                >
                                                    Cancel
                                                </Button>
                                            </Box>
                                        ) : (
                                            <PermissionButton
                                                permission={HOME_PERMISSIONS.ADD_NOTE}
                                                variant="contained"
                                                startIcon={<EditNoteIcon />}
                                                onClick={() => { setNoteEditable(true) }}
                                                sx={standardButtonStyle}
                                            >
                                                Add Note
                                            </PermissionButton>
                                        )}
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={5}>
                            <Box className={classes.sectionCard}>
                                <Box className={classes.sectionLabel}>
                                    View Request
                                </Box>
                                <Box display="flex" flexDirection="row" gap="10px" alignItems="flex-start">
                                    <FormControl
                                        sx={{ flex: 1 }}
                                        variant="outlined" >
                                        <Select
                                            value={viewRequest}
                                            onChange={(e) => {
                                                const selectedViewRequest = e.target.value;
                                                setViewRequest(selectedViewRequest);
                                            }}
                                            size={"small"}
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        '& .MuiMenuItem-root': {
                                                            fontSize: '0.85rem',
                                                            padding: '10px 16px',
                                                        },
                                                    },
                                                },
                                            }}
                                        >
                                            {getViewRequestOptions().map(({ mapping, name, isHidden }) => (
                                                !isHidden && (<MenuItem key={mapping} value={mapping}>
                                                    {name}
                                                </MenuItem>)
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <PermissionButton 
                                        permission={HOME_PERMISSIONS.VIEW_REQUEST}
                                        variant="contained"
                                        startIcon={<ScreenSearchDesktopIcon />}
                                        onClick={() => {
                                            const activeSelection = viewRequest;
                                            const tabInfo = ViewRequestOptions.find((options) => options.mapping === activeSelection);
                                            const allTabs = {
                                                ...activeTabs,
                                                [activeSelection]: {
                                                    dsarRequestId,
                                                    ...tabInfo,
                                                    ...DetailsViewTabs[activeSelection]
                                                }
                                            };
                                            setActiveTabs(allTabs);
                                            setActiveTabIndex((Object.keys(allTabs).indexOf(activeSelection)) + 2);
                                        }}
                                        sx={standardButtonStyle}
                                    >
                                        View Request
                                    </PermissionButton>
                                    <PermissionButton
                                        permission={HOME_PERMISSIONS.CLONE_REQUEST}
                                        variant="contained"
                                        startIcon={<ContentCopy />}
                                        onClick={() => {
                                            axios.post(`/ticket/${dsarRequestId}/clone_ticket`, {}, {
                                                headers: { Authorization: authToken }
                                            }).then(res => {
                                                const cloneJson = res.data?.message;
                                                if (cloneJson) {
                                                    const { dsar_id, ...cloneWithoutDsarId } = cloneJson;
                                                    history.push(`${v2UIRoutePath}admin/createdsr`, {
                                                        cloneJson: JSON.stringify(cloneWithoutDsarId, null, 2)
                                                    });
                                                }
                                            }).catch(err => {
                                                console.log('Error cloning request', err);
                                            });
                                        }}
                                        sx={{
                                            ...standardButtonStyle,
                                            backgroundColor: '#16a34a',
                                            '&:hover': { backgroundColor: '#15803d' },
                                        }}
                                    >
                                        Clone Request
                                    </PermissionButton>
                                </Box>
                            </Box>
                        </Grid>
                        {requestDetails?.status === "Review" && (<Grid item xs={4}>
                            <Box className={classes.sectionCard} height="100%">
                                <Box className={classes.sectionLabel}>
                                    View Manual Review Details
                                </Box>
                                <Box textAlign={"center"} paddingTop="4px">
                                    <Button
                                        variant="contained"
                                        startIcon={<FindInPage />}
                                        onClick={handleViewReviewButton}
                                        sx={standardButtonStyle}
                                    >
                                        View Review
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>)}

                          {!requestDetails?.status || requestDetails?.status !== "Review" ? (
                          <Grid item xs={3}>
                            <Box className={classes.sectionCard} height="100%">
                                <Box className={classes.sectionLabel} justifyContent="center">
                                    Active Litigation Hold
                                </Box>
                                <Box textAlign={"center"} paddingTop="4px">
                                   {requestDetails?.active_litigation_hold ? ( <div className="d-flex justify-content-center" onClick={handleLitigationHoldClick} style={{ cursor: 'pointer' }}>
                                        <img alt="" src="/Lit_hold.png" width="40" height="30"></img>
                                    </div>): <span style={{ color: '#9ca3af', fontSize: '0.82rem' }}>N/A</span>}
                                </Box>
                            </Box>
                        </Grid>
                          ) : null}
                    </Grid>

                    <div className={classes.requestordetailsGridWrapper}>
                        <div className={"header"}>
                            Requestor Details
                        </div>
                        <div style={{ maxHeight: '220px', overflowY: 'auto', overflowX: 'auto' }}>
                            <table>
                                <thead>
                                    <tr>
                                        {(isTVLARequest() ? TVLAGridColumns : isCustomerRequestor() ? CustomerDetailsGridColumns : OtherRequestorGridColumns).map((col, colIndex) => {
                                            const currentWidth = columnWidths[col.mapping] || col.minWidth || 120;
                                            return (
                                                <th 
                                                    key={col.mapping} 
                                                    style={{ 
                                                        width: currentWidth,
                                                        minWidth: col.minWidth || 120 
                                                    }}
                                                >
                                                    {col.name}
                                                    <div
                                                        className="resize-handle"
                                                        onMouseDown={(e) => {
                                                            e.preventDefault();
                                                            const startX = e.clientX;
                                                            const startWidth = currentWidth;

                                                            const handleMouseMove = (e) => {
                                                                const diff = e.clientX - startX;
                                                                const newWidth = Math.max(col.minWidth || 80, startWidth + diff);
                                                                setColumnWidths(prev => ({
                                                                    ...prev,
                                                                    [col.mapping]: newWidth
                                                                }));
                                                            };

                                                            const handleMouseUp = () => {
                                                                document.removeEventListener('mousemove', handleMouseMove);
                                                                document.removeEventListener('mouseup', handleMouseUp);
                                                            };

                                                            document.addEventListener('mousemove', handleMouseMove);
                                                            document.addEventListener('mouseup', handleMouseUp);
                                                        }}
                                                    />
                                                </th>
                                            );
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {(requestDetails.requestorDetailsTable || []).map((row, index) => (
                                        <tr key={row.id || index}>
                                            {(isTVLARequest() ? TVLAGridColumns : isCustomerRequestor() ? CustomerDetailsGridColumns : OtherRequestorGridColumns).map((col) => {
                                                const currentWidth = columnWidths[col.mapping] || col.minWidth || 120;
                                                return (
                                                    <td 
                                                        key={col.mapping} 
                                                        title={row[col.mapping] || ''}
                                                        style={{ width: currentWidth }}
                                                    >
                                                        {row[col.mapping] || ''}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    ))}
                                    {(!requestDetails.requestorDetailsTable || requestDetails.requestorDetailsTable.length === 0) && (
                                        <tr>
                                            <td colSpan={(isTVLARequest() ? TVLAGridColumns : isCustomerRequestor() ? CustomerDetailsGridColumns : OtherRequestorGridColumns).length} style={{ textAlign: 'center', padding: '20px', color: '#64748b' }}>
                                                No data available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
            {activeTabIndex === 1 && (
                <div className={'requestDetailsWrapper'}>
                    <Applications
                        systems={systems}
                        requestDetails={requestDetails}
                        handleReconsolidate={handleConsolidate}
                        reloadInformation={fetchData}
                        handleViewResponseDownstream={handleViewResponseDownstream}
                    />
                </div>
            )}
            {additionalTabInfo && (
                <RequestDetailsJSONTabs
                    handleNewTabOpen={handleNewTabOpen}
                    tabInfo={additionalTabInfo}
                    requestStatus={requestDetails?.status}
                    reloadInformation={fetchData}
                    setLoading={(loading) => { setIsLoading(loading) }}
                    setDisplayErrMsg={setDisplayErrMsg}
                    setDisplaySuccessMsg={setDisplaySuccessMsg}
                />
            )}
            {displayAuditTrail && (
                <AuditTrail
                    hideComponent={() => {
                        setDisplayAuditTrail(false);
                    }}
                    dsarRequestId={dsarRequestId}
                />
            )}
            {displayStatusUpdate && (
                <StatusUpdate
                    hideComponent={(reloadData) => {
                        if (reloadData) {
                            fetchData();
                        }
                        setDisplayStatusUpdate(false);
                    }}
                    data={requestDetails}
                    dsarRequestId={dsarRequestId}
                    setDisplayErrMsg={setDisplayErrMsg}
                    setDisplaySuccessMsg={setDisplaySuccessMsg}
                    setIsLoading={setIsLoading}
                />
            )}
            {displayManualReviewDetails && (<Dialog
                isOpen={!!displayManualReviewDetails}
                isLoading={!manualReviewData}
                updateDialogStatus={() => {
                    setDisplayManualReviewDetails(null);
                    setSelectedManualReviewRows([]);
                    setManualReviewData(null);
                }}
                customHeight="550px"
                customWidth="1150px"
                dialogContent={(
                    <div style={{ 
                        height: '100%', 
                        display: 'flex', 
                        flexDirection: 'column',
                        fontFamily: '"Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                    }}>
                        {/* Selection Summary Bar */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '10px 16px',
                            backgroundColor: '#f5f7fa',
                            borderRadius: '8px',
                            marginBottom: '12px',
                            border: '1px solid #e0e4e8'
                        }}>
                            <span style={{ 
                                fontSize: '0.85rem', 
                                color: '#555',
                                fontWeight: 500
                            }}>
                                {selectedManualReviewRows.length > 0 
                                    ? `${selectedManualReviewRows.length} of ${manualReviewData?.length || 0} record(s) selected`
                                    : `${manualReviewData?.length || 0} record(s) found`
                                }
                            </span>
                            {selectedManualReviewRows.length > 0 && (
                                <button
                                    onClick={() => setSelectedManualReviewRows([])}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        color: '#267db7',
                                        cursor: 'pointer',
                                        fontSize: '0.8rem',
                                        textDecoration: 'underline'
                                    }}
                                >
                                    Clear selection
                                </button>
                            )}
                        </div>

                        {/* Modern Table */}
                        <div style={{ 
                            flex: 1, 
                            overflow: 'auto',
                            borderRadius: '8px',
                            border: '1px solid #e0e4e8',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
                        }}>
                            <table style={{ 
                                width: '100%', 
                                borderCollapse: 'separate',
                                borderSpacing: 0,
                                fontSize: '0.82rem'
                            }}>
                                <thead>
                                    <tr>
                                        <th style={{ 
                                            padding: '12px 8px', 
                                            backgroundColor: '#267db7',
                                            color: 'white',
                                            fontWeight: 600,
                                            textAlign: 'center',
                                            width: '45px',
                                            position: 'sticky',
                                            top: 0,
                                            borderBottom: '2px solid #1a5a8a'
                                        }}>
                                            <input
                                                type="checkbox"
                                                checked={manualReviewData?.length > 0 && 
                                                    selectedManualReviewRows.length === manualReviewData?.filter(row => row.data_type !== 'File-to-Attach-to-Privacy-Report').length &&
                                                    manualReviewData?.filter(row => row.data_type !== 'File-to-Attach-to-Privacy-Report').length > 0}
                                                onChange={(e) => handleManualReviewSelectAll(e.target.checked)}
                                                style={{ 
                                                    width: '16px', 
                                                    height: '16px',
                                                    cursor: 'pointer',
                                                    accentColor: '#267db7'
                                                }}
                                            />
                                        </th>
                                        <th style={{ 
                                            padding: '12px 8px', 
                                            backgroundColor: '#267db7',
                                            color: 'white',
                                            fontWeight: 600,
                                            textAlign: 'center',
                                            width: '45px',
                                            position: 'sticky',
                                            top: 0,
                                            borderBottom: '2px solid #1a5a8a'
                                        }}>#</th>
                                        <th style={{ 
                                            padding: '12px 10px', 
                                            backgroundColor: '#267db7',
                                            color: 'white',
                                            fontWeight: 600,
                                            textAlign: 'left',
                                            position: 'sticky',
                                            top: 0,
                                            borderBottom: '2px solid #1a5a8a',
                                            minWidth: '90px'
                                        }}>App Name</th>
                                        <th style={{ 
                                            padding: '12px 10px', 
                                            backgroundColor: '#267db7',
                                            color: 'white',
                                            fontWeight: 600,
                                            textAlign: 'left',
                                            position: 'sticky',
                                            top: 0,
                                            borderBottom: '2px solid #1a5a8a'
                                        }}>Key</th>
                                        <th style={{ 
                                            padding: '12px 10px', 
                                            backgroundColor: '#267db7',
                                            color: 'white',
                                            fontWeight: 600,
                                            textAlign: 'left',
                                            position: 'sticky',
                                            top: 0,
                                            borderBottom: '2px solid #1a5a8a',
                                            minWidth: '110px'
                                        }}>Data Type</th>
                                        <th style={{ 
                                            padding: '12px 10px', 
                                            backgroundColor: '#267db7',
                                            color: 'white',
                                            fontWeight: 600,
                                            textAlign: 'left',
                                            position: 'sticky',
                                            top: 0,
                                            borderBottom: '2px solid #1a5a8a',
                                            minWidth: '110px'
                                        }}>Review Category</th>
                                        <th style={{ 
                                            padding: '12px 10px', 
                                            backgroundColor: '#267db7',
                                            color: 'white',
                                            fontWeight: 600,
                                            textAlign: 'left',
                                            position: 'sticky',
                                            top: 0,
                                            borderBottom: '2px solid #1a5a8a',
                                            minWidth: '120px'
                                        }}>Value in Request</th>
                                        <th style={{ 
                                            padding: '12px 10px', 
                                            backgroundColor: '#267db7',
                                            color: 'white',
                                            fontWeight: 600,
                                            textAlign: 'left',
                                            position: 'sticky',
                                            top: 0,
                                            borderBottom: '2px solid #1a5a8a',
                                            minWidth: '120px'
                                        }}>Value in Response</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {manualReviewData?.map((row, index) => {
                                        const rowId = index + 1;
                                        const isSelected = selectedManualReviewRows.includes(rowId);
                                        const isRowDisabled = row.data_type === 'File-to-Attach-to-Privacy-Report';
                                        return (
                                            <tr 
                                                key={rowId}
                                                onClick={() => !isRowDisabled && handleManualReviewRowSelect(rowId)}
                                                style={{ 
                                                    backgroundColor: isSelected 
                                                        ? '#fee2e2' 
                                                        : (index % 2 === 0 ? '#ffffff' : '#f8fafc'),
                                                    cursor: isRowDisabled ? 'default' : 'pointer',
                                                    transition: 'all 0.15s ease',
                                                    borderLeft: isSelected ? '3px solid #dc2626' : '3px solid transparent',
                                                    opacity: isRowDisabled ? 0.6 : 1
                                                }}
                                                onMouseEnter={(e) => {
                                                    if (!isSelected) {
                                                        e.currentTarget.style.backgroundColor = '#f1f5f9';
                                                    }
                                                }}
                                                onMouseLeave={(e) => {
                                                    if (!isSelected) {
                                                        e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#f8fafc';
                                                    }
                                                }}
                                            >
                                                <td style={{ 
                                                    padding: '10px 8px', 
                                                    textAlign: 'center',
                                                    borderBottom: '1px solid #e5e7eb'
                                                }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={isSelected}
                                                        disabled={isRowDisabled}
                                                        onChange={() => {}}
                                                        style={{ 
                                                            width: '16px', 
                                                            height: '16px',
                                                            cursor: isRowDisabled ? 'not-allowed' : 'pointer',
                                                            accentColor: '#dc2626'
                                                        }}
                                                    />
                                                </td>
                                                <td style={{ 
                                                    padding: '10px 8px', 
                                                    textAlign: 'center',
                                                    borderBottom: '1px solid #e5e7eb',
                                                    color: '#6b7280',
                                                    fontWeight: 500
                                                }}>{rowId}</td>
                                                <td style={{ 
                                                    padding: '10px', 
                                                    borderBottom: '1px solid #e5e7eb',
                                                    fontWeight: 500,
                                                    color: '#374151'
                                                }}>{row.app_name}</td>
                                                <td style={{ 
                                                    padding: '10px', 
                                                    borderBottom: '1px solid #e5e7eb',
                                                    color: '#4b5563',
                                                    maxWidth: '200px',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }} title={row.key}>{row.key}</td>
                                                <td style={{ 
                                                    padding: '10px', 
                                                    borderBottom: '1px solid #e5e7eb',
                                                    color: '#4b5563',
                                                    maxWidth: '200px',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }} title={row.data_type}>{row.data_type}</td>
                                                <td style={{ 
                                                    padding: '10px', 
                                                    borderBottom: '1px solid #e5e7eb'
                                                }}>
                                                    <span style={{
                                                        backgroundColor: '#dbeafe',
                                                        color: '#1e40af',
                                                        padding: '3px 8px',
                                                        borderRadius: '12px',
                                                        fontSize: '0.75rem',
                                                        fontWeight: 500
                                                    }}>
                                                        {row.review_category}
                                                    </span>
                                                </td>
                                                <td style={{ 
                                                    padding: '10px', 
                                                    borderBottom: '1px solid #e5e7eb',
                                                    color: '#059669',
                                                    fontWeight: 500,
                                                    maxWidth: '150px',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }} title={row.request_value}>{row.request_value}</td>
                                                <td style={{ 
                                                    padding: '10px', 
                                                    borderBottom: '1px solid #e5e7eb',
                                                    color: '#dc2626',
                                                    fontWeight: 500,
                                                    maxWidth: '150px',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }} title={row.response_value}>{row.response_value}</td>
                                            </tr>
                                        );
                                    })}
                                    {(!manualReviewData || manualReviewData.length === 0) && (
                                        <tr>
                                            <td colSpan={8} style={{ 
                                                padding: '40px', 
                                                textAlign: 'center', 
                                                color: '#9ca3af',
                                                fontSize: '0.9rem'
                                            }}>
                                                <div style={{ marginBottom: '8px' }}>📋</div>
                                                No records available for review
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Action Bar */}
                        <div style={{ 
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            paddingTop: '16px',
                            gap: '12px'
                        }}>
                            {!isAdmin && (
                                <span style={{ 
                                    fontSize: '0.8rem', 
                                    color: '#9ca3af',
                                    fontStyle: 'italic'
                                }}>
                                    🔒 Admin access required for this action
                                </span>
                            )}
                            <button
                                onClick={handleRemoveAndReconsolidateClick}
                                disabled={selectedManualReviewRows.length === 0 || !isAdmin}
                                style={{
                                    background: (selectedManualReviewRows.length === 0 || !isAdmin) 
                                        ? 'linear-gradient(135deg, #d1d5db 0%, #9ca3af 100%)'
                                        : 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
                                    color: 'white',
                                    padding: '12px 24px',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: (selectedManualReviewRows.length === 0 || !isAdmin) ? 'not-allowed' : 'pointer',
                                    fontSize: '0.875rem',
                                    fontWeight: 600,
                                    boxShadow: (selectedManualReviewRows.length === 0 || !isAdmin) 
                                        ? 'none' 
                                        : '0 4px 6px -1px rgba(37, 99, 235, 0.3)',
                                    transition: 'all 0.2s ease',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}
                                onMouseEnter={(e) => {
                                    if (selectedManualReviewRows.length > 0 && isAdmin) {
                                        e.currentTarget.style.transform = 'translateY(-1px)';
                                        e.currentTarget.style.boxShadow = '0 6px 10px -1px rgba(37, 99, 235, 0.4)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = (selectedManualReviewRows.length === 0 || !isAdmin) 
                                        ? 'none' 
                                        : '0 4px 6px -1px rgba(37, 99, 235, 0.3)';
                                }}
                            >
                                <Delete style={{ fontSize: '1.2rem' }} />
                                Remove & Reconsolidate
                            </button>
                        </div>
                    </div>
                )}
                title={(
                    <Box paddingBottom={"5px"}>
                        <div className='modelheader' style={{ fontSize: '1.1rem', fontWeight: 600 }}>Manual Review Details</div>
                        <span style={{ color: '#6b7280', fontSize: '0.85rem' }}>Request ID</span> : <span style={{ fontWeight: 500 }}>{dsarRequestId}</span>
                    </Box>
                )}
            />)}
            {showRemoveConfirmation && (
                <DeleteDialog
                    openDeleteDialog={showRemoveConfirmation}
                    handleDeleteDialogClose={handleRemoveConfirmationClose}
                    title={"Confirm Remove & Reconsolidate"}
                    handleDeleteDialogSubmit={handleRemoveAndReconsolidateSubmit}
                    closeButtonText="No"
                    submitButtonText="Yes"
                >
                    This action will permanently remove the selected data from downstream response. Do you wish to proceed?
                </DeleteDialog>
            )}
            {showVehiclesPopup && (
                <MuiDialog
                    open={true}
                    maxWidth={false}
                    PaperProps={{
                        style: {
                            width: '750px',
                            maxWidth: '750px',
                            height: '60vh',
                            maxHeight: '60vh',
                        }
                    }}
                >
                    <DialogTitle
                        sx={{
                            background: 'linear-gradient(135deg, #1e3a5f 0%, #267db7 125%, #3b9edd 100%)',
                            color: '#fff',
                            padding: '8px 24px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                        disableTypography
                    >
                        <span style={{ fontSize: '1.1rem', fontWeight: 600, letterSpacing: '0.3px' }}>Vehicles</span>
                        <button
                            onClick={() => setShowVehiclesPopup(false)}
                            aria-label="close"
                            style={{
                                color: '#fff',
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                padding: '6px',
                                display: 'flex',
                                alignItems: 'center',
                                borderRadius: '50%',
                            }}
                        >
                            <Close fontSize="small" />
                        </button>
                    </DialogTitle>
                    <DialogContent sx={{ padding: '0 !important', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                        <div className={classes.requestordetailsGridWrapper} style={{ margin: '20px', flex: 1, overflowY: 'auto', border: 'none', boxShadow: 'none' }}>
                            <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: '60px', textAlign: 'center' }}>#</th>
                                        <th style={{ textAlign: 'center' }}>VIN</th>
                                        <th style={{ textAlign: 'center' }}>Generation</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {vehicleGenInfo.vehicles.map((vehicle) => (
                                        <tr key={vehicle.id}>
                                            <td style={{ width: '60px', textAlign: 'center' }}>{vehicle.id}</td>
                                            <td style={{ textAlign: 'center', fontWeight: 600 }}>{vehicle.vin}</td>
                                            <td style={{ textAlign: 'center', fontWeight: 700 }}>{vehicle.generation}</td>
                                        </tr>
                                    ))}
                                    {vehicleGenInfo.vehicles.length === 0 && (
                                        <tr>
                                            <td colSpan={3} style={{ textAlign: 'center', padding: '20px', color: '#64748b' }}>
                                                No vehicle data available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </DialogContent>
                </MuiDialog>
            )}
        </div>
    );
}

export default withNavbar(withRouterProps(RequestDetailView), 0, 1);
